// @ts-check
import React from 'react';
import cx from 'classnames';
import styles from './QuickFillButton.module.scss';

const QuickFillButton = ({ active, children, ...props }) => {
  return (
    <button
      type="button"
      className={cx(styles.btn, {
        [styles.active]: active,
      })}
      {...props}
    >
      {children}
    </button>
  );
};

export default QuickFillButton;
